module.exports = __webpack_public_path__ + "static/media/distances_GO_P.51191e78.csv";